export const INITIAL_STATE_CUSTOMER_PROPERTIES = {
  id: null,
  idCliente: null,
  nome: null,
  cpfCnpj: null,
  ipr: null,
  area: null,
  endereco: null,
  numero: null,
  complemento: null,
  bairro: null,
  cidade: null,
  uf: null,
  ibge: null,
  cep: null,
  telefone: null,
  celular: null,
  email: null,
  observacao: null,
  latitude: null,
  longitude: null,
  status: "ativo",
}

export const INVALID_FIELDS_CUSTOMER_PROPERTIES = {
  nome: "",
  cpfCnpj: "",
  cidade: "",
  uf: "",
  cep: "",
}